module.exports = __webpack_public_path__ + "static/media/loader.be00fc4a.svg";